import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import TablaActividades from "./listadoActividades/TablaActividades";
import { actividadesOps } from "../../ducks/actividades";
import _ from "lodash";

class ListadoAactividades extends React.Component {
  state = {
    redirect: false
  };

  componentDidMount() {
    this.props.obtenerListaActividades();
  }

  componentWillUnmount() {
    this.props.resetListaActividades();
  }

  handleRowClick = id => {
    this.props.obtenerDetalleActividad(id);
    this.setState({
      redirect: true,
      redirectItem: <Redirect push to={`/detalle/actividad/${id}`} />
    });
  };
  handleVolver = () => this.props.history.goBack();

  render() {
    if (this.state.redirect) {
      return this.state.redirectItem;
    }

    return (
      <Transition.Group animation="scale" duration={250}>
        {!_.isEmpty(this.props.listaActividades) && (
          <Container textAlign="center">
            <Segment basic>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <Header inverted as="h2">
                Listado de Actividades
              </Header>
            </Segment>
            <Segment loading={_.isEmpty(this.props.listaActividades)}>
              <TablaActividades
                listaActividades={this.props.listaActividades}
                handleRowClick={this.handleRowClick}
              />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({
  listaActividades: state.actividades.listaActividades
});

const actions = {
  obtenerDetalleActividad: actividadesOps.obtenerDetalleActividad,
  obtenerListaActividades: actividadesOps.obtenerListaActividades,
  resetListaActividades: actividadesOps.resetListaActividades
};

export default connect(mapStateToProps, actions)(ListadoAactividades);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoActividades.jsx